import {combineReducers, type Reducer} from 'redux'
import staticReducers from './static-reducers'

const rootReducer = (asyncReducers: Record<string, Reducer> = {}) =>
    combineReducers({
        ...staticReducers,
        ...asyncReducers,
    })

export default rootReducer
